import { ProgressCircle } from '@pwc/pwc-deals-ui/';
import React from 'react';
import { useParams } from 'react-router-dom';

import SidebarNavItem from '../../SidebarNavItem/SidebarNavItem';
import { formatSurveySectionRoute } from '../../../../../Survey/routes';
import './SectionNav.scss';

const SectionNav = ({ section }) => {
  const { projectId } = useParams();
  const fullSectionPath = formatSurveySectionRoute(projectId, section.path);
  const inProgress =
    section.numQuestionsAnswered > 0 &&
    section.numQuestionsAnswered !== section.numQuestionsTotal;

  return (
    <SidebarNavItem path={fullSectionPath}>
      <span className="progress-ph nowrap">
        <ProgressCircle
          label={section.title}
          current={section.numQuestionsAnswered}
          total={section.numQuestionsTotal}
          displaySteps={inProgress}
        />
      </span>
    </SidebarNavItem>
  );
};

export default SectionNav;
